import {countries} from './countries.json';

const getCountries = (locale = 'en') => countries[locale];

export default getCountries;
